export enum FilterValues {
    NEW = 'new',
    ARCHIVED = 'archived',
}
